/**
 * OwnerAdminSeats — platform-wide seat economics for the SaaS Owner-Admin
 * console. Renders the shared AdminSeatsTab component inside the
 * OwnerAdminLayout chrome. Pulls /api/owner-admin/seats-overview.
 *
 * Use case: identify high-seat customers + workspaces over their plan cap
 * (the upsell-outreach list) at a glance.
 */
import AdminSeatsTab from '../admin/AdminSeatsTab';

export default function OwnerAdminSeats() {
  return (
    <div className="p-6 space-y-6 max-w-7xl mx-auto" data-testid="owner-admin-seats-page">
      <div>
        <h1 className="text-2xl font-semibold">Seats &amp; Capacity</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Platform-wide rollup of seat usage, add-on MRR, and workspaces over their plan cap.
        </p>
      </div>
      <AdminSeatsTab />
    </div>
  );
}
